import { Component, Input } from "@angular/core";
import { savingButtonAnimation } from "@app/animations";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";

@Component({
  templateUrl: "./button-circle-save.component.html",
  selector: "button-circle-save",
})
export class ButtonCircleSaveComponent {
  public NO_STATUS: string = "";
  public SAVING_STATUS: string = "saving";
  public SAVED_STATUS: string = "saved";
  public FAILED_STATUS: string = "failed";
  @Output("click") click = new EventEmitter();

  disabled: boolean = true;
  public _status: string = this.NO_STATUS;

  get status() {
    return this._status;
  }

  @Input()
  set status(status: string) {
    this._status = status;

    if (
      this._status === this.SAVED_STATUS ||
      this._status === this.FAILED_STATUS
    ) {
      this.reinitSubmitButton();
    }
  }

  private reinitSubmitButton() {
    setTimeout(() => {
      this._status = this.NO_STATUS;
    }, 2000);
  }

  save() {
    console.log("emit");
    this.click.emit();
  }
}
